import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import _ from 'lodash';

import MeasurementGuide from '../../../utilities/measurement_guide'
import './measurements.css'

// const bodyParts = [
//   { neck: 'neckCollarGirth' },
//   { bust: 'bustGirth' },
//   { chest: 'chestAtBladesGirth' },
//   { waist: 'waistSmallBackGirth' },
//   { hips: 'seatGirth' },
//   { leftBiceps: 'bicepsLeftGirth' },
//   { rightBiceps: 'bicepsRightGirth' },
//   { leftForearm: 'forearmLeftGirth' },
//   { rightForearm: 'forearmRightGirth' },
//   { leftThigh: 'thighLeftMaxGirth' },
//   { rightThigh: 'thighRightMaxGirth' },
//   { leftCalf: 'calfLeftGirth' },
//   { rightCalf: 'calfRightGirth' }
// ];

export default class Measurements extends Component {
  constructor(props) {
    super(props)

    this.measurementKeyNameList = {
      neckCollarGirth: 'Neck',
      chestAtBladesGirth: 'Chest',
      bustGirth: 'Bust',
      waistSmallBackGirth: 'Waist',
      seatGirth: 'Hips',
      bicepsLeftGirth: 'Left Biceps',
      bicepsRightGirth: 'Right Biceps',
      forearmLeftGirth: 'Left Forearm',
      forearmRightGirth: 'Right Forearm',
      thighLeftMaxGirth: 'Left Thigh',
      thighRightMaxGirth: 'Right Thigh',
      calfLeftGirth: 'Left Calf',
      calfRightGirth: 'Right Calf',
    }

    const gender = props.gender
    const keyToDelete = gender === 'Female' ? 'chestAtBladesGirth' : 'bustGirth'

    delete this.measurementKeyNameList[keyToDelete]

    this.state = {
      selectedMeasurement: null,
    }
  }

  updateSelectedMeasurement(measurement) {
    this.setState({ selectedMeasurement: measurement })
  }

  renderImage() {
    // let bodyPartsCopy = bodyParts.slice();
    // const keyToDelete = this.props.gender === 'Female' ? 'chestAtBladesGirth' : 'bustGirth';

    // const genderParsedParts = _.filter(bodyPartsCopy, part => Object.values(part)[0] !== keyToDelete);

    return (
      <div className="my-3 mx-auto demoImageContainer">
        <MeasurementGuide gender={this.props.gender} />
        {/* <div className='mapToolTips'>
          { genderParsedParts.map(bodyPart => {
            let bodyPartKey = Object.keys(bodyPart)[0];
            let bodyPartValue = bodyPart[bodyPartKey];

            return (
              <div
                key={ bodyPartKey }
                className={ bodyPartKey }
                onMouseEnter={ this.updateSelectedMeasurement.bind(this, bodyPartValue) }
                onMouseLeave={ this.updateSelectedMeasurement.bind(this, null) }>
                <div className={ `${bodyPartKey}ToolTip` }>{ this.measurementKeyNameList[bodyPartValue] }</div>
              </div>
          );}) }
        </div> */}
      </div>
    )
  }

  renderMeasurementsData() {
    const { scanMeasurements } = this.props

    return Object.keys(this.measurementKeyNameList).map((measurement) => {
      const measurementName = this.measurementKeyNameList[measurement]
      const value = scanMeasurements.get(measurement)

      const style = { fontSize: '16px' }

      if (this.state.selectedMeasurement === measurement) {
        style.background = '#1686b0'
        style.color = 'white'
      }

      // add the image column here
      if (measurement === 'neckCollarGirth') {
        return (
          <tr key={measurement}>
            <td rowSpan="12" className="text-center" style={{ width: '500px' }}>
              {this.renderImage()}
              <div>
                * Note: The sample image is only used to display measurement
                locations and body parts. The table on the right displays the
                client's measurements.
              </div>
            </td>
            <td style={style}>{measurementName}</td>
            <td style={style}>{value}</td>
          </tr>
        )
      }
      return (
        <tr key={measurement}>
          <td style={style}>{measurementName}</td>
          <td style={style}>{value}</td>
        </tr>
      )
    })
  }

  render() {
    const units = this.props.units === 'US' ? 'Inches' : 'cm'
    return (
      <div className="mb-5">
        <h2 className="mb-3">Measurements</h2>
        <div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th style={{ fontSize: '16px' }}>
                  Demo Location Guide (Sample Image)*
                </th>
                <th style={{ fontSize: '16px' }}>Name</th>
                <th style={{ fontSize: '16px' }}>
                  <span>Value</span>
                  <span> ({units})</span>
                </th>
              </tr>
            </thead>
            <tbody>{this.renderMeasurementsData()}</tbody>
          </table>
        </div>
      </div>
    )
  }
}

Measurements.propTypes = {
  scanMeasurements: PropTypes.object,
  packageId: PropTypes.string,
  gender: PropTypes.string,
  units: PropTypes.string.isRequired,
}
